import BaseModel from "./BaseModel";

export default class SubscriptionsModel extends BaseModel {
  private _amount: number;
  private _minPaymentInCents: number;
  private _remainingAmountInCents: number;
  private _expiredAt?: String | null;
  private _isActive?: boolean;
  private _subscriptionType?: String;
  constructor(arg: any) {
    super(arg);
    this._amount = arg.amount;
    this._expiredAt = arg.expired_at;
    this._isActive = !!arg.is_active ? arg.is_active : false;
    this._subscriptionType = arg.subscription_type;
    this._remainingAmountInCents = arg.remaining_amount;
    this._minPaymentInCents = arg.min_payment_amount;
  }

  get amount() {
    return this._amount;
  }

  get minPayment() {
    return this._minPaymentInCents / 100;
  }

  get maxPayment() {
    return this._remainingAmountInCents / 100;
  }

  get expiredAt() {
    return this._expiredAt;
  }

  get isActive() {
    return this._isActive;
  }

  get subscriptionType() {
    return this._subscriptionType;
  }
}
